import { replace } from 'lodash'
import mixpanelCli, { type Dict } from 'mixpanel-browser'
import ReactGA from 'react-ga'
import TagManager from 'react-gtm-module'

ReactGA.initialize('UA-109026539-1')

interface AnalyticsConfig {
  MIXPANEL_TOKEN?: string
  GTM_ID?: string
  user?: {
    id: string
    firstLogin?: boolean
  }
  home?: {
    id: string
    name: string
    createdOn: string
  }
}

declare global {
  interface Window {}
}

export const mixpanel = {
  track: (eventName: string, eventProps: Dict | undefined) => {
    try {
      mixpanelCli.track(eventName, eventProps)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Mixpanel error', e)
    }
  }
}

export const initialiseAnalytics = ({
  MIXPANEL_TOKEN,
  GTM_ID,
  user,
  home
}: AnalyticsConfig) => {
  if (!home || !user || !user.id) return
  if (MIXPANEL_TOKEN) {
    mixpanelCli.init(MIXPANEL_TOKEN)
    mixpanelCli.identify(user.id)
  }
  if (GTM_ID) TagManager.initialize({ gtmId: GTM_ID })
}

export const gaPageView = (page: string) => {
  ReactGA.pageview(page)
}

export const gaRouteTracking = () => {
  let path = window.location.pathname
  path = replace(path, /[a-f\d]{24}/i, ':id')
  if (path === '/' || path === '' || path === '/') {
    path = '/home-dashboard'
  }
  gaPageView(path)
}

export const gaEvent = ({
  category,
  action,
  label
}: {
  category?: string
  action: string
  label?: string
}) => {
  ReactGA.event({
    // @ts-ignore
    category, // the group of similar events. Eg: Downloads, Forms, Navigation, Error, OutboundLinks
    action, // the type of event. Eg: Hospital Passport, Open Create Resident Modal, Create Resident
    label // more specific details. Eg the name of the web page element, the ADL name, the Risk Assessment name etc.
  })
}
